import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import moment from 'moment'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'

import {toastr} from 'react-redux-toastr'

import config from '../../config'
import Pagination from '../pagination'

library.add(faAngleDown)
library.add(faAngleUp)

const RenderOrderBy = ({selectedKey, state}) => {
  console.log('!!!!!!!!!!!!!!!!!!!!!!!', selectedKey, state)
  if (state.order.key === selectedKey) {
    if (state.order.direction === 'ASC') {
      return <FontAwesomeIcon icon="angle-down" />
    } else {
      return <FontAwesomeIcon icon="angle-up" />
    }
  }
  return <span></span>
}

class ConsentsListComponent extends Component {
  constructor(props){
    super(props)
    this.state = {
      selectedConsents: [],
      consents: [],
      count: 0,
      loaded: false,
      selectedPreferredLanguages: [],
      selectedOrgs: [],
      perPage: 50,
      page: 1,
      aggregation: {},
      order: {
        key: 'updated',
        direction: 'DESC'
      }
    }
  }

  componentDidMount() {
    this.getConsents()

    axios.get(`${config.apiUrl}/consents/aggregate`)
      .then(response => {
        if (response.data.data) {
          this.setState({aggregation: response.data.data})
        }
      }).catch(error => console.log(error))
  }

  getConsents = () => {
    let queryString = '?';
    this.state.page ? queryString += `&page=${this.state.page}` : null
    this.state.perPage ? queryString += `&perPage=${this.state.perPage}` : null

    if (this.state.selectedOrgs.length > 0 ) {
      this.state.selectedOrgs.forEach(org => {
        queryString += `&org=${encodeURIComponent(org)}`
      })
    }

    if (this.state.selectedPreferredLanguages.length > 0 ) {
      this.state.selectedPreferredLanguages.forEach(lang => {
        queryString += `&preferredLanguage=${encodeURIComponent(lang)}`
      })
    }

    if (this.state.order.key && this.state.order.direction) {
      queryString += `&key=${this.state.order.key}&order=${this.state.order.direction}`
    }

    axios.get(`${config.apiUrl}/consents${queryString}`)
      .then(response => {
        if (response.data.data && response.data.data.rows && response.data.data.count) {
          this.setState({consents: response.data.data.rows, count: response.data.data.count}, () => {
            this.setState({loaded: true})
          })
        }
      })
      .catch(error => {
        console.error(error)
      })
  };

  downloadExcelFile = () => {
    let queryString = '?';
    this.state.page ? queryString += `&page=${this.state.page}` : null
    this.state.perPage ? queryString += `&perPage=${this.state.perPage}` : null

    if (this.state.selectedOrgs.length > 0 ) {
      this.state.selectedOrgs.forEach(org => {
        queryString += `&org=${encodeURIComponent(org)}`
      })
    }

    if (this.state.selectedPreferredLanguages.length > 0 ) {
      this.state.selectedPreferredLanguages.forEach(lang => {
        queryString += `&preferredLanguage=${encodeURIComponent(lang)}`
      })
    }
    axios.post(`${config.apiUrl}/generate-excel/consents${queryString}`)
      .then(function (response) {
        console.log(response.data)
        window.location.href = response.data.url
      })
      .catch(function (error) {
        console.error(error)
      })
  };

  deleteConsent = (user, consent) => {
    const _this = this
    axios.delete(`${config.apiUrl}/users/${user.id}/consents/${consent.id}`)
    .then(function(response) {
      toastr.success('Consent slettet')
      _this.getConsents()
    })
    .catch(function(error) {
      toastr.success('Kunne ikke slette bruker', error)
    })
  };

  paginate = (e, key) => {
    e.preventDefault()
    let page = this.state.page
    if (typeof key === 'number') {
      page = key
    } else if (key === 'next') {
      page = page + 1
    } else if (key === 'previous') {
      page = page - 1
    }
    this.setState({page: page}, () => this.getConsents())
  };

  toggleOrder = (key) => {
    // 1. If column is not set OR not right key, then set it to key AND 'ASC'
    if (!this.state.order.key) {
      const order = {...this.state.order}
      order.key = key
      order.direction = 'ASC'
      this.setState({order: order}, () => this.getConsents())
    }
    // 2. Else if column is key but asc is set, then set desc
    else if (this.state.order.key === key && this.state.order.direction === 'ASC') {
      const order = {...this.state.order}
      order.key = key
      order.direction = 'DESC'
      this.setState({order: order}, () => this.getConsents())
    }
    // 3. REMOVE ORDER
    else {
      this.setState({order: {key: null, direction: null}}, () => this.getConsents())
    }
  };

  render () {
    const { consents, selectedConsents, selectedOrgs, selectedPreferredLanguages, aggregation } = this.state;
    return (
       <div className="container-fluid">
          <h1>Consents</h1>

          <div className="row mb-4">
            <div className="col">
              <button className="btn btn-primary" onClick={e => this.downloadExcelFile()}>Download excel</button>
            </div>
            {aggregation.orgOptions &&
              <div className="col col-sm-auto">
                <form className="form-inline mb-4">
                  <div className="form-group">
                    Filter by Org:
                  </div>
                  {aggregation.orgOptions.map(org => (
                    <div className="form-check form-check-inline ml-3" key={org.DISTINCT}>
                      <input className="form-check-input" type="checkbox" id={`checkbox-${org.DISTINCT}`} value={org.DISTINCT} checked={selectedOrgs.indexOf(org.DISTINCT) !== -1 ? 'checked' : ''} onChange={e => {
                        if (selectedOrgs.indexOf(org.DISTINCT) === -1) {
                          const selectedOrgsCopy = [...selectedOrgs]
                          selectedOrgsCopy.push(org.DISTINCT)
                          this.setState({selectedOrgs: selectedOrgsCopy, page: 1}, () => this.getConsents())
                        } else {
                          const selectedOrgsCopy = [...selectedOrgs]
                          selectedOrgsCopy.splice(selectedOrgsCopy.indexOf(org.DISTINCT), 1)
                          this.setState({selectedOrgs: selectedOrgsCopy, page: 1}, () => this.getConsents())
                        }
                      }} />
                      <label className="form-check-label" htmlFor={`checkbox-${org.DISTINCT}`}>{org.DISTINCT}</label>
                    </div>
                  ))}
                </form>
              </div>
            }
            {aggregation.preferredLanguageOptions &&
              <div className="col col-sm-auto">
                <form className="form-inline mb-4">
                  <div className="form-group">
                    Filter by preferred language:
                  </div>
                  {aggregation.preferredLanguageOptions.map(pfLang => (
                    <div className="form-check form-check-inline ml-3" key={pfLang.DISTINCT}>
                      <input className="form-check-input" type="checkbox" id={`checkbox-${pfLang.DISTINCT}`} value={pfLang.DISTINCT} checked={selectedPreferredLanguages.indexOf(pfLang.DISTINCT) !== -1 ? 'checked' : ''} onChange={e => {
                        if (selectedPreferredLanguages.indexOf(pfLang.DISTINCT) === -1) {
                            const selectedPreferredLanguagesCopy = [...selectedPreferredLanguages]
                            selectedPreferredLanguagesCopy.push(pfLang.DISTINCT)
                            this.setState({selectedPreferredLanguages: selectedPreferredLanguagesCopy, page: 1}, () => this.getConsents())
                          } else {
                            const selectedPreferredLanguagesCopy = [...selectedPreferredLanguages]
                            selectedPreferredLanguagesCopy.splice(selectedPreferredLanguagesCopy.indexOf(pfLang.DISTINCT), 1)
                            this.setState({selectedPreferredLanguages: selectedPreferredLanguagesCopy, page: 1}, () => this.getConsents())
                          }
                      }} />
                      <label className="form-check-label" htmlFor={`checkbox-${pfLang.DISTINCT}`}>{pfLang.DISTINCT === 'nb' ? 'Norwegian' : 'English'}</label>
                    </div>
                  ))}
                </form>
              </div>
            }
          </div>

          <Pagination paginate={this.paginate.bind(this)} page={this.state.page} perPage={this.state.perPage} count={this.state.count} rows={consents} />

          <table className="table table-striped table-bordered table-hover">
            <thead className="thead-dark">
              <tr>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone</th>
                <th>Org</th>
                <th>Consents</th>
                <th>Preferred language</th>
                <th className="h-clickable" onClick={e => this.toggleOrder('updated')}>Updated <RenderOrderBy selectedKey="updated" state={this.state} /></th>
                <th>Wants to be deleted</th>
                <th>Wants to be deleted date</th>
              </tr>
            </thead>
            <tbody>
              {consents.map((consent) => {
                const user = consent.users[0]
                return (
                  <tr className="th-hover" key={consent.id}>
                    <td>{user.email || 'Unknown'}</td>
                    <td>{user.firstName || 'Unknown'}</td>
                    <td>{user.lastName || 'Unknown'}</td>
                    <td>{user.phone || 'Unknown'}</td>
                    <td>{consent.org || 'Unknown'}</td>
                    <td>{consent.consents && consent.consents.map((co, index) => `${co}${((index +1) !== consent.consents.length) ? ', ' : ''}`)}</td>
                    <td>{user.preferredLanguage === 'nb' && 'Norwegian' || user.preferredLanguage === 'en' && 'English' || 'Unknown'}</td>
                    <td>{consent.updated && moment(consent.updated).format('DD/MM/YYYY HH:mm')}</td>
                    {
                      consent.wantsToBeDeleted
                      ? <td className="d-flex flex-grow justify-content-center align-items-center">yes<button className="btn btn-danger btn-delete--consent" onClick={e => this.deleteConsent(user, consent)}>Slett</button></td>
                      : <td></td>
                    }
                    <td>{consent.wantsToBeDeletedDate && moment(consent.wantsToBeDeletedDate).format('DD/MM/YYYY HH:mm')}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          {consents.length === 0 && <div>Ingen treff</div>}
          <Pagination paginate={this.paginate.bind(this)} page={this.state.page} perPage={this.state.perPage} count={this.state.count} rows={this.state.consents} />
        </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    layout: state.layout
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
  }
}

const ConsentsList = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsentsListComponent);

export default ConsentsList



// WEBPACK FOOTER //
// ./src/components/consents-list/index.js